import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const resolveMedia = (url) => {
  if (!url) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};

export const api = axios.create({ baseURL: API });

export const setAdminToken = (token) => {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("vb_admin_token", token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("vb_admin_token");
  }
};

const stored = typeof window !== "undefined" ? localStorage.getItem("vb_admin_token") : null;
if (stored) api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;

export const getStoredToken = () => (typeof window !== "undefined" ? localStorage.getItem("vb_admin_token") : null);
